var ElementConfig = /** @class */ (function () {
    function ElementConfig(elementConfig) {
        if (elementConfig === undefined) {
            elementConfig = {
                'className': '',
                'placeholder': '',
                'type': '',
                'options': [],
                'showTime': false,
                'minDate': null,
                'maxDate': null,
                'hourFormat': '',
                'futureDateValidation': false,
                'items': [],
                'selectedItems': [],
                'maxSelectedItems': 5,
                'readOnlyInput': true,
                'multiple': false,
                'noClose': false,
                'step': '',
                'min': '',
                'max': ''
            };
        }
        this.className = elementConfig.className;
        this.placeholder = elementConfig.placeholder;
        this.type = elementConfig.type;
        this.options = elementConfig.options;
        this.showTime = elementConfig.showTime;
        this.minDate = elementConfig.minDate;
        this.maxDate = elementConfig.maxDate;
        this.hourFormat = elementConfig.hourFormat;
        this.futureDateValidation = elementConfig.futureDateValidation;
        this.items = elementConfig.items;
        this.selectedItems = elementConfig.selectedItems;
        this.maxSelectedItems = elementConfig.maxSelectedItems;
        this.readOnlyInput = elementConfig.readOnlyInput;
        this.multiple = elementConfig.multiple;
        this.noClose = elementConfig.noClose;
        this.step = elementConfig.step;
        this.min = elementConfig.min;
        this.max = elementConfig.max;
        this.dateFormat = elementConfig.dateFormat;
    }
    return ElementConfig;
}());
export default ElementConfig;
var DropdownOption = /** @class */ (function () {
    function DropdownOption(dropdownOption) {
        if (dropdownOption === undefined) {
            dropdownOption = {
                'label': '',
                'value': ''
            };
        }
        this.label = dropdownOption.label;
        this.value = dropdownOption.value;
    }
    return DropdownOption;
}());
export { DropdownOption };



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/formItem/ElementConfig.ts
// module id = 7
// module chunks = 0